import { render, staticRenderFns } from "./TopTime.vue?vue&type=template&id=6228bcff&scoped=true"
import script from "./TopTime.vue?vue&type=script&lang=js"
export * from "./TopTime.vue?vue&type=script&lang=js"
import style0 from "./TopTime.vue?vue&type=style&index=0&id=6228bcff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6228bcff",
  null
  
)

export default component.exports